
/* Use this decorator on SaveConfigService class's datasource methods
to validate whether required fields exist in url search parameters.
 */
export function ValidateParams(options: {
    requiredFields: string[];           // required fields in URL search parameters
    errorMessage?: string;              // error message if check fails (optional). If missing, then use default
    paramsIndex: number;                // function argument index for params
    openSnackBarFuncIndex: number;      // function argument index for openSnackBar
    snackBarParamIndex: number;         // function argument index for snackBar
}) {
    return function (target: any, propertyKey: string, descriptor: PropertyDescriptor) {
        options.errorMessage = options.errorMessage || `Authentication failed for ${propertyKey}`;

        let originalFunc = descriptor.value;
        descriptor.value = function (...args) {
            const params = args[options.paramsIndex];
            const snackBar = args[options.snackBarParamIndex];
            const openSnackBarWarning = args[options.openSnackBarFuncIndex];
            if (options.requiredFields.every(k => params[k])) {
                originalFunc.apply(this, args);
            } else {
                openSnackBarWarning(snackBar, options.errorMessage, 'close');
            }
        }
    };
}